require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sub-fire-5-demo.json") })
        }
      }, "path---sub-fire-5-demo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sub-fire-5-demo!./.cache/json/sub-fire-5-demo.json
// module id = 370
// module chunks = 231608221292675